import TasksModule from '@modules/TasksModule';
import { inboxActions } from '../state';
import type { DeferredSelection } from '@modules/TasksModule/types';

/**
 * Applies the latest selection request that arrived while a Close prompt held
 * selection and still names a live task, falling back to earlier requests
 * newest first. A target of `undefined` means the home view.
 */
export function applyDeferredSelection(
  deferred: DeferredSelection | undefined,
) {
  if (!deferred) {
    return;
  }
  const candidates = [
    deferred.target,
    ...[...(deferred.fallbacks ?? [])].reverse(),
  ];
  const index = candidates.findIndex(
    (target) => target === undefined || TasksModule.getTask(target),
  );
  if (index !== -1) {
    inboxActions.setSelectedTaskId(candidates[index]);
  }
}
